import type { MerchantConfig } from "@/data/merchant-types"

interface MerchantDisplayProps {
  merchant: MerchantConfig
  shopFrontPosition?: { top?: string; right?: string; left?: string }
  characterPosition?: { top?: string; right?: string; left?: string; zIndex?: number }
  onShopFrontClick?: () => void
  isMobile?: boolean
  showBubble?: boolean
}

export const MerchantDisplay = ({
  merchant,
  shopFrontPosition = { top: "55%", right: "0" },
  characterPosition = { top: "55%", right: "20px", zIndex: 5 },
  onShopFrontClick,
  isMobile = false,
  showBubble = false,
}: MerchantDisplayProps) => {
  // 20% smaller on mobile: 160 * 0.8 = 128, 100 * 0.8 = 80
  const shopFrontSize = isMobile ? 128 : 160
  const characterSize = isMobile ? 80 : 100

  return (
    <>
      <div
        className={`absolute z-30 ${onShopFrontClick ? "cursor-pointer hover:brightness-110 transition-all" : ""}`}
        style={{
          top: shopFrontPosition.top,
          right: shopFrontPosition.right,
          left: shopFrontPosition.left,
          transform: shopFrontPosition.top?.includes("%") ? "translateY(-50%)" : undefined,
        }}
        onClick={onShopFrontClick}
      >
        <img
          src={merchant.shopFront || "/placeholder.svg"}
          alt="Shop Front"
          width={shopFrontSize}
          height={shopFrontSize}
          className="w-auto h-auto drop-shadow-[0_0_40px_rgba(255,140,0,0.9)]"
          style={{ imageRendering: "pixelated" }}
        />
        {/* Tutorial bubble - z-50 to render above shop item cards (z-40) */}
        {showBubble && (
          <div
            className="absolute pointer-events-none transition-opacity duration-300 z-50"
            style={{
              left: "50%",
              top: "-8px",
              transform: "translateX(-50%) translateY(-100%)",
            }}
          >
            <div
              className="relative bg-black border border-white/50 rounded-lg px-3 py-2 text-white text-center whitespace-nowrap"
              style={{ fontSize: "12px" }}
            >
              <div>Buy, Sell & Reroll</div>
              {/* Diamond pointer pointing DOWN */}
              <div
                className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-3 h-3 bg-black border-r border-b border-white/50 rotate-45"
              />
            </div>
          </div>
        )}
      </div>
      <div
        className="absolute"
        style={{
          top: characterPosition.top,
          right: characterPosition.right,
          left: characterPosition.left,
          zIndex: characterPosition.zIndex,
          transform: characterPosition.top?.includes("%") ? "translateY(-50%)" : undefined,
          filter:
            "drop-shadow(0 0 80px rgba(255, 140, 0, 1)) drop-shadow(0 0 50px rgba(255, 140, 0, 1)) drop-shadow(0 0 30px rgba(255, 140, 0, 0.9))",
        }}
      >
        <img
          src={merchant.characterImage || "/placeholder.svg"}
          alt={merchant.name}
          width={characterSize}
          height={characterSize}
          className="w-auto h-auto"
          style={{ imageRendering: "pixelated" }}
        />
      </div>
    </>
  )
}
